import { isBlank1dvkhjjvox3p0 as isBlank } from '../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  toString1pkumu07cwy4m as toString,
  equals2au1ep9vhcato as equals,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  hashCodeq5arwsb9dgti as hashCode,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  checkNameIsNotAPrimitive28vmhppr4nskt as checkNameIsNotAPrimitive,
  PrimitiveDescriptorSafe1r3pht5v1oaqu as PrimitiveDescriptorSafe,
} from '../internal/Primitives.mjs';
import {
  PrimitiveKindndgbuh6is7ze as PrimitiveKind,
  CLASS_getInstance25nhr3t715wdo as CLASS_getInstance,
} from './SerialKinds.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  toList383f556t1dixk as toList,
  withIndex3s8q7w1g0hyfn as withIndex,
} from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Arrays.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { HashSet2dzve9y63nf0v as HashSet } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/HashSet.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import {
  toStringImpl1y3u8fza7vdq as toStringImpl,
  hashCodeImplfv8qiy3re24s as hashCodeImpl,
} from '../internal/PluginGeneratedSerialDescriptor.mjs';
import {
  SerialDescriptor2pelqekb5ic3a as SerialDescriptor,
  get_isNullable36pbikm8xb7bz as get_isNullable,
  get_isInline5x26qrhi9qs6 as get_isInline,
} from './SerialDescriptor.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import {
  toHashSet1qrcsl3g8ugc8 as toHashSet,
  toBooleanArray2u3qw7fjwsmuh as toBooleanArray,
} from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { copyToArray2j022khrow2yi as copyToArray } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { compactArray1b2nl9rkq8nuz as compactArray } from '../internal/Platform.common.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { toMap1vec9topfei08 as toMap } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import {
  getChecked1o70dkx10jwym as getChecked,
  getChecked3avs2psuwt1xd as getChecked_0,
} from '../internal/Platform.mjs';
import { contentEqualsaf55p28mnw74 as contentEquals } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_ArraysJs.mjs';
import { CachedNames2minxlyafeo07 as CachedNames } from '../internal/CachedNames.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function SerialDescriptor_0(serialName, original) {
  // Inline function 'kotlin.text.isNotBlank' call
  // Inline function 'kotlin.require' call
  if (!!isBlank(serialName)) {
    var message = 'Blank serial names are prohibited';
    throw IllegalArgumentException().n2(toString(message));
  }
  // Inline function 'kotlin.require' call
  if (!!(serialName === original.u1n())) {
    var message_0 = 'The name of the wrapped descriptor (' + serialName + ') cannot be the same as the name of the original descriptor (' + original.u1n() + ')';
    throw IllegalArgumentException().n2(toString(message_0));
  }
  var tmp = original.n1p();
  if (tmp instanceof PrimitiveKind()) {
    checkNameIsNotAPrimitive(serialName);
  }
  return new (WrappedSerialDescriptor())(serialName, original);
}
function PrimitiveSerialDescriptor(serialName, kind) {
  // Inline function 'kotlin.text.isNotBlank' call
  // Inline function 'kotlin.require' call
  if (!!isBlank(serialName)) {
    var message = 'Blank serial names are prohibited';
    throw IllegalArgumentException().n2(toString(message));
  }
  return PrimitiveDescriptorSafe(serialName, kind);
}
function buildClassSerialDescriptor(serialName, typeParameters, builderAction) {
  var tmp;
  if (builderAction === VOID) {
    tmp = buildClassSerialDescriptor$lambda;
  } else {
    tmp = builderAction;
  }
  builderAction = tmp;
  // Inline function 'kotlin.text.isNotBlank' call
  // Inline function 'kotlin.require' call
  if (!!isBlank(serialName)) {
    var message = 'Blank serial names are prohibited';
    throw IllegalArgumentException().n2(toString(message));
  }
  var sdBuilder = new (ClassSerialDescriptorBuilder())(serialName);
  builderAction(sdBuilder);
  return new (SerialDescriptorImpl())(serialName, CLASS_getInstance(), sdBuilder.f1n_1.q2(), toList(typeParameters), sdBuilder);
}
var ClassSerialDescriptorBuilderClass;
function ClassSerialDescriptorBuilder() {
  if (ClassSerialDescriptorBuilderClass === VOID) {
    class $ {
      constructor(serialName) {
        this.c1n_1 = serialName;
        this.d1n_1 = false;
        this.e1n_1 = emptyList();
        this.f1n_1 = ArrayList().p2();
        this.g1n_1 = HashSet().ga();
        this.h1n_1 = ArrayList().p2();
        this.i1n_1 = ArrayList().p2();
        this.j1n_1 = ArrayList().p2();
      }
      c1q(elementName, descriptor, annotations, isOptional) {
        // Inline function 'kotlin.require' call
        if (!this.g1n_1.i2(elementName)) {
          var message = "Element with name '" + elementName + "' is already registered in " + this.c1n_1;
          throw IllegalArgumentException().n2(toString(message));
        }
        // Inline function 'kotlin.collections.plusAssign' call
        this.f1n_1.i2(elementName);
        // Inline function 'kotlin.collections.plusAssign' call
        this.h1n_1.i2(descriptor);
        // Inline function 'kotlin.collections.plusAssign' call
        this.i1n_1.i2(annotations);
        // Inline function 'kotlin.collections.plusAssign' call
        this.j1n_1.i2(isOptional);
      }
      k1n(elementName, descriptor, annotations, isOptional, $super) {
        annotations = annotations === VOID ? emptyList() : annotations;
        isOptional = isOptional === VOID ? false : isOptional;
        var tmp;
        if ($super === VOID) {
          this.c1q(elementName, descriptor, annotations, isOptional);
          tmp = Unit_instance;
        } else {
          tmp = $super.c1q.call(this, elementName, descriptor, annotations, isOptional);
        }
        return tmp;
      }
    }
    initMetadataForClass($, 'ClassSerialDescriptorBuilder');
    ClassSerialDescriptorBuilderClass = $;
  }
  return ClassSerialDescriptorBuilderClass;
}
function buildSerialDescriptor(serialName, kind, typeParameters, builder) {
  var tmp;
  if (builder === VOID) {
    tmp = buildSerialDescriptor$lambda;
  } else {
    tmp = builder;
  }
  builder = tmp;
  // Inline function 'kotlin.text.isNotBlank' call
  // Inline function 'kotlin.require' call
  if (!!isBlank(serialName)) {
    var message = 'Blank serial names are prohibited';
    throw IllegalArgumentException().n2(toString(message));
  }
  // Inline function 'kotlin.require' call
  if (!!equals(kind, CLASS_getInstance())) {
    var message_0 = "For StructureKind.CLASS please use 'buildClassSerialDescriptor' instead";
    throw IllegalArgumentException().n2(toString(message_0));
  }
  var sdBuilder = new (ClassSerialDescriptorBuilder())(serialName);
  builder(sdBuilder);
  return new (SerialDescriptorImpl())(serialName, kind, sdBuilder.f1n_1.q2(), toList(typeParameters), sdBuilder);
}
var WrappedSerialDescriptorClass;
function WrappedSerialDescriptor() {
  if (WrappedSerialDescriptorClass === VOID) {
    class $ {
      constructor(serialName, original) {
        this.d1q_1 = serialName;
        this.e1q_1 = original;
      }
      u1n() {
        return this.d1q_1;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof WrappedSerialDescriptor()))
          return false;
        return this.d1q_1 === other.d1q_1 && equals(this.e1q_1, other.e1q_1);
      }
      hashCode() {
        var result = getStringHashCode(this.d1q_1);
        result = imul(31, result) + hashCode(this.e1q_1) | 0;
        return result;
      }
      toString() {
        return toStringImpl(this);
      }
      n1p() {
        return this.e1q_1.n1p();
      }
      g1p() {
        return this.e1q_1.g1p();
      }
      o1p() {
        return this.e1q_1.o1p();
      }
      p1p() {
        return this.e1q_1.p1p();
      }
      q1p() {
        return this.e1q_1.q1p();
      }
      r1p(index) {
        return this.e1q_1.r1p(index);
      }
      s1p(name) {
        return this.e1q_1.s1p(name);
      }
      t1p(index) {
        return this.e1q_1.t1p(index);
      }
      u1p(index) {
        return this.e1q_1.u1p(index);
      }
      v1p(index) {
        return this.e1q_1.v1p(index);
      }
    }
    initMetadataForClass($, 'WrappedSerialDescriptor', VOID, VOID, [SerialDescriptor()]);
    WrappedSerialDescriptorClass = $;
  }
  return WrappedSerialDescriptorClass;
}
function _get__hashCode__tgwhef($this) {
  var tmp0 = $this.q1q_1;
  var tmp = KProperty1();
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('_hashCode', 1, tmp, SerialDescriptorImpl$_get__hashCode_$ref_2v7wzp(), null);
  return tmp0.n3();
}
function SerialDescriptorImpl$_get__hashCode_$ref_2v7wzp() {
  return (p0) => _get__hashCode__tgwhef(p0);
}
var SerialDescriptorImplClass;
function SerialDescriptorImpl() {
  if (SerialDescriptorImplClass === VOID) {
    class $ {
      constructor(serialName, kind, elementsCount, typeParameters, builder) {
        this.f1q_1 = serialName;
        this.g1q_1 = kind;
        this.h1q_1 = elementsCount;
        this.i1q_1 = builder.e1n_1;
        this.j1q_1 = toHashSet(builder.f1n_1);
        var tmp = this;
        // Inline function 'kotlin.collections.toTypedArray' call
        var this_0 = builder.f1n_1;
        tmp.k1q_1 = copyToArray(this_0);
        this.l1q_1 = compactArray(builder.h1n_1);
        var tmp_0 = this;
        // Inline function 'kotlin.collections.toTypedArray' call
        var this_1 = builder.i1n_1;
        tmp_0.m1q_1 = copyToArray(this_1);
        this.n1q_1 = toBooleanArray(builder.j1n_1);
        var tmp_1 = this;
        // Inline function 'kotlin.collections.map' call
        var this_2 = withIndex(this.k1q_1);
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList().h2(collectionSizeOrDefault(this_2, 10));
        var _iterator__ex2g4s = this_2.p1();
        while (_iterator__ex2g4s.q1()) {
          var item = _iterator__ex2g4s.r1();
          var tmp$ret$4 = to(item.ck_1, item.bk_1);
          destination.i2(tmp$ret$4);
        }
        tmp_1.o1q_1 = toMap(destination);
        this.p1q_1 = compactArray(typeParameters);
        var tmp_2 = this;
        tmp_2.q1q_1 = lazy(() => hashCodeImpl(this, this.p1q_1));
      }
      u1n() {
        return this.f1q_1;
      }
      n1p() {
        return this.g1q_1;
      }
      p1p() {
        return this.h1q_1;
      }
      q1p() {
        return this.i1q_1;
      }
      r1q() {
        return this.j1q_1;
      }
      r1p(index) {
        return getChecked(this.k1q_1, index);
      }
      s1p(name) {
        var tmp0_elvis_lhs = this.o1q_1.u4(name);
        return tmp0_elvis_lhs == null ? -3 : tmp0_elvis_lhs;
      }
      t1p(index) {
        return getChecked(this.m1q_1, index);
      }
      u1p(index) {
        return getChecked(this.l1q_1, index);
      }
      v1p(index) {
        return getChecked_0(this.n1q_1, index);
      }
      equals(other) {
        var tmp$ret$0;
        $l$block_5: {
          // Inline function 'kotlinx.serialization.internal.equalsImpl' call
          if (this === other) {
            tmp$ret$0 = true;
            break $l$block_5;
          }
          if (!(other instanceof SerialDescriptorImpl())) {
            tmp$ret$0 = false;
            break $l$block_5;
          }
          if (!(this.u1n() === other.u1n())) {
            tmp$ret$0 = false;
            break $l$block_5;
          }
          if (!contentEquals(this.p1q_1, other.p1q_1)) {
            tmp$ret$0 = false;
            break $l$block_5;
          }
          if (!(this.p1p() === other.p1p())) {
            tmp$ret$0 = false;
            break $l$block_5;
          }
          var inductionVariable = 0;
          var last = this.p1p();
          if (inductionVariable < last)
            do {
              var index = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              if (!(this.u1p(index).u1n() === other.u1p(index).u1n())) {
                tmp$ret$0 = false;
                break $l$block_5;
              }
              if (!equals(this.u1p(index).n1p(), other.u1p(index).n1p())) {
                tmp$ret$0 = false;
                break $l$block_5;
              }
            }
             while (inductionVariable < last);
          tmp$ret$0 = true;
        }
        return tmp$ret$0;
      }
      hashCode() {
        return _get__hashCode__tgwhef(this);
      }
      toString() {
        return toStringImpl(this);
      }
    }
    protoOf($).g1p = get_isNullable;
    protoOf($).o1p = get_isInline;
    initMetadataForClass($, 'SerialDescriptorImpl', VOID, VOID, [SerialDescriptor(), CachedNames()]);
    SerialDescriptorImplClass = $;
  }
  return SerialDescriptorImplClass;
}
function buildClassSerialDescriptor$lambda(_this__u8e3s4) {
  return Unit_instance;
}
function buildSerialDescriptor$lambda(_this__u8e3s4) {
  return Unit_instance;
}
//region block: exports
export {
  PrimitiveSerialDescriptor as PrimitiveSerialDescriptor3egfp53lutxj2,
  SerialDescriptor_0 as SerialDescriptorbzxbhtn690r4,
  buildClassSerialDescriptor as buildClassSerialDescriptors2a6xdp6mrtw,
  buildSerialDescriptor as buildSerialDescriptor2873qmkp8r2ib,
};
//endregion

//# sourceMappingURL=SerialDescriptors.mjs.map
